import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibGoogle,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibCcStripe,
  cibCcPaypal,
  cibCcApplePay,
  cibCcAmex,
  
} from '@coreui/icons'
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from '@coreui/icons'
import {
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilArrowLeft,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCamera,
  cilCalendar,
  cilCalendarCheck,
  cilClock,
  cilDescription,
  cilCloudDownload,
  cilCloudUpload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMediaPlay,
  cilMenu,
  cilReload,
  cilShare,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilPlus,
  cilPrint,
  cilTrash,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilHome,
  cilSwapHorizontal,
  cilStorage,
  cilTransfer,
  cilLowVision,
  cilAccountLogout,
  cilCart,
  cilWallet,
  cilInbox,
  cilMoney,
  cilMedicalCross,
  cilWarning,
  cilCopy,
  cilChatBubble,
  cilQrCode,
  cilContact,
  cilColorPalette,
} from '@coreui/icons'

// cil-eye tidak ada di @coreui/icons 3.0.1; dibuat dengan format yang sama (viewBox + path)
const cilEye = [
  '512 512',
  "<path fill='var(--ci-primary-color, currentColor)' fill-rule='evenodd' d='M256 96C144 96 52 170 16 256c36 86 128 160 240 160s204-74 240-160C460 170 368 96 256 96Zm0 32c-92 0-168 58-203 128 35 70 111 128 203 128s168-58 203-128c-35-70-111-128-203-128Z' class='ci-primary'/><circle cx='256' cy='256' r='80' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>",
]

export const iconsSet = Object.assign(
  {},
  {
    cilEye,
    cilMedicalCross,
    cilWarning,
    cilCopy,
    cilChatBubble,
    cilQrCode,
    cilContact,
    cilColorPalette,
    cilLowVision,
    cilAccountLogout,
    cilCart,
    cilWallet,
    cilInbox,
    cilMoney,
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilArrowLeft,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCamera,
    cilCalendar,
    cilCalendarCheck,
    cilClock,
    cilDescription,
    cilCloudDownload,
    cilCloudUpload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCode,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMediaPlay,
    cilMenu,
    cilReload,
    cilShare,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilPlus,
    cilPrint,
    cilTrash,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilHome,
    cilSwapHorizontal,
    cilStorage,
    cilTransfer,
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibGoogle,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibCcStripe,
    cibCcPaypal,
    cibCcApplePay,
    cibCcAmex,
  },
)
